import {Component} from '@angular/core';
import {ViewController} from 'ionic-angular';
import {NavParams} from 'ionic-angular/navigation/nav-params';
import {Action} from '../../bean/action';

@Component({
    templateUrl: 'popoverpage.html',
})
export class PopoverpageComponent {
    menus: Action[] = [];
    observer: any;

    constructor(
        public viewCtrl: ViewController,
        public navParams: NavParams
    ) {
        this.init();
    }

    init() {
        let data = this.navParams.get('data');
        this.observer = this.navParams.get('observer');
        this.menus = data.map(item => new Action(item));
    }

    doAction(item: Action) {
        this.observer.doAction(item);
        this.viewCtrl.dismiss();

    }
}

// /**
//  * Generated class for the PopoverpageComponent component.
//  *
//  * See https://angular.io/api/core/Component for more info on Angular
//  * Components.
//  */
// @Component({
//   selector: 'popoverpage',
//   templateUrl: 'popoverpage.html'
// })
// export class PopoverpageComponent {

//   text: string;

//   constructor() {
//     console.log('Hello PopoverpageComponent Component');
//     this.text = 'Hello World';
//   }

// }



// WEBPACK FOOTER //
// ./src/components/popoverpage/popoverpage.ts